import React, { useState, useEffect, Fragment } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment, HourglassEmpty, Visibility } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button';
import { Link, useParams } from 'react-router-dom';

import { wsGet } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import { Paper, Tooltip } from '@material-ui/core';
import moment from 'moment';
import { currency } from 'hooks/Pipe';
import CardFooter from 'components/Card/CardFooter';
import { Toasty, useToasty } from 'hooks/Toasty';
import AlertConfirm from './CancelApprove/AlertConfirm';
import { useModal } from 'hooks/useModal';
import ModalApprove from './CancelApprove/ModalApprove';
import { ConstantPermissions } from 'contexts/useConstant';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import PendientOrdersModal from 'components/Tvendo/Order/PendientOrdersModal';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  detail: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '10px',
      marginRight: '10px',
      fontWeight: 'bold',
      fontSize: '15px',
    },
  },
  paper: {
    padding: '0px 11px 4px 10px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 140 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Tipo', accessor: 'type', width: 120 },
  { Header: 'U. Comprome.', accessor: 'commited_units', width: 130 },
  { Header: 'Paquete', accessor: 'packages', width: 100 },
  { Header: 'Unidad', accessor: 'units', width: 100 },
  { Header: 'Unid. paq.', accessor: 'units_package', width: 120 },
  { Header: 'Precio unit.', accessor: 'units_price', width: 120 },
  { Header: 'Precio Paq.', accessor: 'package_price', width: 120 },
  { Header: 'Monto', accessor: 'amount', width: 120 },
  { Header: 'Descuento', accessor: 'discount', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function OrdmOrderDetailShared(props) {
  const classes = useStyles();
  const { id } = useParams();
  const { idOrder = id, reload = undefined, cancelApprove = undefined } = props;
  const [notify, showNotify] = useToasty(); //notificación despues de las
  const [processing, setProcessing] = useState(false);

  const [order, setOrder] = useState({});
  const [orderDetails, setOrderDetails] = useState([]);

  //opcion para aprobar o anular
  const [dataConfirm, setDataConfirm] = useState({ show: false });
  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [pendientModel, setPendientModel] = useModal();

  async function getOrder() {
    setProcessing(true);
    let response = await wsGet('ordm/order', idOrder);
    setProcessing(false);
    if (response.success) {
      setOrder(response.data);
      setOrderDetails(response.data?.details);
    }
  }

  useEffect(() => {
    getOrder();
    return () => {
      setOrder({});
      setOrderDetails([]);
    };
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />

      <ModalApprove model={model} setOpen={setOpen} showNotify={showNotify} reload={reload} />
      <PendientOrdersModal model={pendientModel} setOpen={setPendientModel} />
      <AlertConfirm
        {...dataConfirm}
        showNotify={showNotify}
        close={() => setDataConfirm({ show: false })}
        reload={reload}
      />

      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de detalles del pedido ({processing ? 'Cargando...' : order.id})</h4>
        </CardHeader>
        <CardBody>
          <GridContainer style={{ marginBottom: '15px' }}>
            {/* Vendedor */}
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Vendedor: </h5>
                <span>{processing ? '...' : order.SlpName}</span>
              </Paper>
            </GridItem>
            {/* CardName */}
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Cliente: </h5>
                <span>{processing ? '...' : order.CardName}</span>
              </Paper>
            </GridItem>
            {/* Dirección */}
            <GridItem xs={12} lg={6} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Dirección: </h5>
                <span>{processing ? '...' : order.Address2}</span>
              </Paper>
            </GridItem>
            {/* Total */}
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Total: </h5>
                <span>{processing ? '...' : currency(order.total_amount)}</span>
              </Paper>
            </GridItem>
            {/* Estado */}
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Estado: </h5>
                <span>
                  {processing ? '...' : order.state === 'X'
                    ? 'Pendiente'
                    : order.state === 'S'
                    ? 'Sin Stock'
                    : order.state === 'A'
                    ? 'Anulado'
                    : order.state === 'E'
                    ? 'Editado'
                    : order.state === 'P'
                    ? 'Procesado'
                    : 'Retenido'}
                </span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Fecha: </h5>
                <span>{processing ? '...' : moment(order.start_date).format('DD/MM/YYYY HH:mm:ss')}</span>
              </Paper>
            </GridItem>
          </GridContainer>

          <ReactTable
            excelName="Detalles-de-pedidos"
            defaultWidth={1400}
            columns={columns}
            colorRow={(item) => {
              return item.type == 'Bonificación'
                ? '#43ff6b61'
                : item.type === 'Descuento'
                ? '#ff81001f'
                : '';
            }}
            data={orderDetails.map((orderDetail, i) => {
              return {
                num: !orderDetail.prom_promotion_id ? undefined : (
                  <div className="actions-right">
                    {i + 1}
                    <Link
                      to={`/admin/articulos/operaciones/promociones/${orderDetail.prom_promotion_id}`}
                      target="_blank"
                    >
                      <Visibility style={{ fontSize: 18 }} />
                    </Link>
                  </div>
                ),
                ItemCode: orderDetail.ItemCode,
                ItemName: orderDetail.ItemName,
                type:
                  orderDetail.type === 'B'
                    ? 'Bonificación'
                    : orderDetail.DiscPrcnt > 0 && orderDetail.DiscPrcnt < 100
                    ? 'Descuento'
                    : orderDetail.type === 'N'
                    ? 'Normal'
                    : '-',
                commited_units: orderDetail.commited_units,
                packages: orderDetail.packages,
                units: orderDetail.units,
                units_package: orderDetail.units_package,
                units_price: currency(orderDetail.units_price),
                package_price: currency(orderDetail.package_price),
                amount: currency(orderDetail.amount),
                discount: `${
                  parseFloat(orderDetail.discount) == 0
                    ? 0
                    : parseFloat(orderDetail.discount).toFixed(2)
                }%`,
                actions: '',
              };
            })}
          />

          {order.state === 'R' ? (
            <RetainedContainer
              order={order}
              setPendientModel={setPendientModel}
            />
          ) : undefined}
        </CardBody>
        {!cancelApprove ? undefined : (
          <CardFooter>
            <div style={{ width: '100%', textAlign: 'end' }}>
              <AllowedGuard permission={ConstantPermissions.ORDM_ORDERS_APPROVE_RETAINED_ORDER}>
                <Button
                  color={props.themeContext.buttonColorSuccess}
                  onClick={() => {
                    if (order.digitate_discount == 0) {
                      setDataConfirm({
                        show: true,
                        idOrder: order.id,
                        message: 'Aprobar',
                        action: 'Y',
                      });
                    } else {
                      setOpen(order);
                    }
                  }}
                >
                  Aprobar
                </Button>
              </AllowedGuard>
              <AllowedGuard permission={ConstantPermissions.ORDM_ORDERS_ANNULAR_RETAINED_ORDER}>
                <Button
                  style={{ marginLeft: '15px' }}
                  color={props.themeContext.buttonColorDanger}
                  onClick={() => {
                    setDataConfirm({
                      show: true,
                      idOrder: order.id,
                      message: 'Anular',
                      action: 'N',
                    });
                  }}
                >
                  Anular
                </Button>
              </AllowedGuard>
            </div>
          </CardFooter>
        )}
      </Card>
    </Fragment>
  );
});

/**
 * Ver razones de retencion en caso de
 */
function RetainedContainer(props) {
  const { order, setPendientModel } = props;
  const classes = useStyles();
  const [reasons, setReasons] = useState([]);

  useEffect(() => {
    if (order.retention_reasons != undefined) {
      setReasons(order.retention_reasons.split(', '));
    }
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} lg={3} className={classes.detail}>
        <h5>Razones retenido</h5>
        <ul>
          {reasons.map((retentionReason, i) => {
            return (
              <li key={i}>
                {retentionReason}
                {(retentionReason.includes('tiene ordenes vencidas') ||
                  retentionReason.includes('solicitud de crédito')) && (
                  <Tooltip title="Pendientes de pago">
                    <Button
                      justIcon
                      round
                      color="info"
                      size="sm"
                      onClick={() => {
                        setPendientModel(order);
                      }}
                    >
                      <HourglassEmpty />
                    </Button>
                  </Tooltip>
                )}
              </li>
            );
          })}
        </ul>
      </GridItem>
    </GridContainer>
  );
}

